import Vue from 'vue'
import App from './App.vue'
import './assets/css/base.css'

import './assets/js/base.js'

new Vue({
  render: h => h(App),
}).$mount('#app')
